import React, { useState, useEffect } from "react";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import { Categories } from "../../helpers";
import { Formik } from 'formik';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },

    formHeading: {
        fontSize: '20px !important',
        marginTop: 0,
        marginBottom: 10,
        textTransform: "uppercase",
        fontWeight: 600,
        padding: '8px 24px'
    }
}));


export default function CreateImageModal({ handleClose, open, editImage }) {
    const [categories, setCategories] = useState([]);
    const classes = useStyles();

    const getCategoriesData = async () => {
        let resp = await Categories.getCategoriesWithTopLevel();
        if (resp && resp.status) {
            console.log(resp.categories);
            setCategories(resp.categories);
        }
    }
    useEffect(() => {
        getCategoriesData();
    }, [])

    const handleSubmitForm = (values, { resetForm }) => {
        editImage(values)
    }
    return (
        <div>


            <Dialog
                maxWidth="sm"
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                fullWidth
            >
                <h3 className={classes.formHeading}>Create Image</h3>
                <Formik
                    initialValues={{ image_name: '', image_size: '', image_category: '' }}
                    validate={values => {
                        const errors = {};
                        if (!values.image_name) {
                            errors.image_name = 'Name is required !';
                        }
                        if (!values.image_size) {
                            errors.image_size = 'Size is required !';
                        }
                        if (!values.image_category) {
                            errors.image_category = 'Category is required !';
                        }
                        return errors;
                    }}
                    onSubmit={handleSubmitForm}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                    }) => (<form onSubmit={handleSubmit}>
                        <DialogContent>
                            <div className={classes.root}>
                                <div className="form-group">
                                    <label>Image Name</label>
                                    <input type="text"
                                        className="form-control"
                                        placeholder="Enter image name"
                                        name="image_name"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.image_name}
                                    />
                                    {errors.image_name && touched.image_name && <span className="help-error">{errors.image_name}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Image Size</label>
                                    <input type="text"
                                        className="form-control"
                                        placeholder="Enter image size"
                                        name="image_size"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.image_size}
                                    />
                                    {errors.image_size && touched.image_size && <span className="help-error">{errors.image_size}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Image Category</label>


                                    <select className='form-control' name="image_category" onChange={handleChange} onBlur={handleBlur} value={values.image_category}>
                                        <option value={``}>---Select Category---</option>
                                        {
                                            categories && categories.length !== 0 && categories.map((item, i) => {
                                                return (
                                                    <>
                                                        <option value={item.id} className='maincategory'>{item.name}</option>
                                                        {
                                                            item.subcategories.map(item2 => {
                                                                return (
                                                                    <>
                                                                        <option value={item2.id} className='subcategory'>{item2.name}</option>
                                                                        {
                                                                            item2.subcategories.map(item3 => {
                                                                                return (
                                                                                    <>
                                                                                    <option value={item3.id} className='subsubcategory'>  {`>> ${item3.name}`}</option>
                                                                                    {
                                                                                        item3.subcategories.map(item4 => {
                                                                                           return <option value={item4.id} className='subsubcategory'>  {`>>> ${item4.name}`}</option>
                                                                                        })
                                                                                    }
                                                                                    </>
                                                                                
                                                                                )
                                                                            })
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }

                                                    </>

                                                )
                                            })
                                        }
                                    </select>

                                    {/* <select
                                        className="form-control"
                                        name="image_category"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.image_category}>
                                        <option value="">--Select Category--</option>
                                        {
                                            categories && categories.map((item, i) => {
                                                return <option value={item.id} key={i}>{item.name}</option>
                                            })
                                        }
                                    </select> */}
                                    {errors.image_category && touched.image_category && <span className="help-error">{errors.image_category}</span>}
                                </div>


                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button autoFocus variant="contained" onClick={handleClose} color="secondary">
                                Close
                            </Button>
                            <Button type="submit" variant="contained" color="primary">
                                submit
                            </Button>

                        </DialogActions>
                    </form>)}
                </Formik>
            </Dialog>
        </div>
    );
}